export default __webpack_public_path__ + "static/media/gat.2ebf10c7.jpeg";